import React from 'react';

import { BaseAIGeneratorDrawer } from '../BaseAIGeneratorDrawer';

import { usePresentationMakerGeneratorFormWithLogic } from './hooks/usePresentationMakerGeneratorFormWithLogic';

/**
 * @param {Object} props
 * @param {undefined} [props.leftContent]
 * @param {string} [props.submitButtonName]
 * @param {string} [props.title]
 * @param {Object} [props.defaultPresentationContent]
 * @param {Array} [props.footerExtraButtons]
 * @param {boolean} [props.open]
 * @param {boolean} [props.isAutoRetrievalEnabled]
 * @param {Object} props.optionsExtendedParams
 * @param {boolean} [props.isFormEnabled]
 * @param {Function} props.onClickGenerate
 * @param {Function} [props.onClickRateButton]
 * @param {Function} props.onClose
 * @param {Function} [props.renderErrorState]
 * @param {Function} [props.renderInitialState]
 * @param {string} [props.presentationTypeId]
 */
export const PresentationMakerGeneratorDrawer = ({
  defaultPresentationContent = null,
  footerExtraButtons = [],
  isAutoRetrievalEnabled = false,
  isFormEnabled = true,
  leftContent,
  onClickGenerate,
  onClickRateButton,
  onClose,
  open = true,
  optionsExtendedParams = {},
  presentationTypeId = null,
  renderErrorState,
  renderInitialState,
  rightContentFooter,
  submitButtonName,
  title,
  ...otherProps
}) => {
  return (
    <BaseAIGeneratorDrawer
      autoGenerationConfig={{
        enabled: isAutoRetrievalEnabled,
        defaultContent: defaultPresentationContent,
        condition: presentationTypeId,
        presentationTypeId,
        defaultPresentationContent,
        footerExtraButtons,
        onClickGenerate,
        onClickRateButton
      }}
      footerExtraButtons={footerExtraButtons}
      formHook={usePresentationMakerGeneratorFormWithLogic}
      isFormEnabled={isFormEnabled}
      leftContent={leftContent}
      onClickGenerate={onClickGenerate}
      onClickRateButton={onClickRateButton}
      onClose={onClose}
      open={open}
      optionsExtendedParams={optionsExtendedParams}
      renderErrorState={renderErrorState}
      renderInitialState={renderInitialState}
      rightContentFooter={rightContentFooter}
      submitButtonName={submitButtonName}
      title={title}
      {...otherProps}
    />
  );
};
